import { Injectable } from "@angular/core";
import { AddressPurchase } from "../sync-prices-cart/interfaces/purchase.interface";
import { from, Observable, throwError } from "rxjs";
import { StorageService } from "../storage.service";

@Injectable({ providedIn: 'root' })
export class UserGetAddressCleanService {
  constructor(private localStorageSevice: StorageService) { }

  getCurrentAddress(): Observable<AddressPurchase> {
    const addressStorage = this.localStorageSevice.getItem('selected_address') as AddressPurchase;

    if (!addressStorage) {
      return throwError('No address selected');
    }

    const address: AddressPurchase = {
      ad_id: addressStorage.ad_id,
      ad_latitude: addressStorage.ad_latitude,
      ad_longitude: addressStorage.ad_longitude,
      ad_full_address: addressStorage.ad_full_address,
      ad_user_id: addressStorage.ad_user_id,
      ad_zone_id: addressStorage.ad_zone_id,
      created_at: addressStorage.created_at,
      updated_at: addressStorage.updated_at,
      ad_reference: addressStorage.ad_reference,
      ad_name: addressStorage.ad_name
    }
    // console.log(from([address]));

    return from([address]);
  }

}